module.exports = __webpack_public_path__ + "img/creepy_ldoge.c94495aa.svg";